import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "aria-label": "A complete example of page header",
  style: {"padding":"0 10rem"}
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "flex items-center" }

import { ElNotification as notify } from 'element-plus'
  import { ref, reactive } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import CardText from '@/components/CardText.vue'
  import Table from '@/components/Table.vue'
  import CarouselComponent from '@/components/CarouselComponent.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: ['value'],
  setup(__props) {

  const props = __props;
  const data = props.value;


  const router = useRouter();
  const onBack = () => {
    router.back();
    // notify('Back')
  }
  const redirect = () => {
    router.push(data.inquiryPath);
  }

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_page_header = _resolveComponent("el-page-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, { onBack: onBack }, {
      breadcrumb: _withCtx(() => [
        _createVNode(_component_el_breadcrumb, { separator: "/" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, {
              to: { path: _unref(data).rootPath }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(data).root), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: _unref(data).currentPath
                }, _toDisplayString(_unref(data).current), 9, _hoisted_2)
              ]),
              _: 1
            }),
            (_unref(data).isDetail)
              ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(data).detail), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      extra: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "button-23",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (redirect()))
          }, "Inquiry")
        ])
      ]),
      default: _withCtx(() => [
        (_unref(data).isPara)
          ? (_openBlock(), _createBlock(CardText, {
              key: 0,
              value: _unref(data).paragraph
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_unref(data).isTable)
          ? (_openBlock(), _createBlock(Table, {
              key: 1,
              value: _unref(data).table
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_unref(data).isCarousel)
          ? (_openBlock(), _createBlock(CarouselComponent, {
              key: 2,
              value: _unref(data).img
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})